<template>
  <Transition name="fade">
    <div class="modal-outer-wrapper" v-if="visible">
      <div class="modal-background" @click="$emit('close')"></div>
      <div class="modal-wrapper" :style="getStyle()">
        <div class="modal-header">
          <h1>{{ heading }}</h1>
          <span v-html="getSVG('x')" @click="$emit('close')" />
        </div>
        <slot />
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--overlay);
  z-index: 10000;
}

.modal-outer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
}

.modal-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--surface);
  border-radius: var(--radius-modal);
  padding: 28px;
  z-index: 10500;
  min-width: 380px;
  max-width: calc(100% - 40px);
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  padding-right: 30px;
  margin-bottom: 18px;
}

.modal-header h1 {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 0;
}

.modal-header :deep(svg) {
  position: absolute;
  right: 20px;
  top: 26px;
  width: 20px;
  height: 20px;
  color: var(--text-muted);
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
export default {
  data() {
    return {}
  },
  emits: [
    "close",
  ],
  props: [
    "visible",
    "heading",
    "width",
  ],
  watch: {
    visible(val) {
      if(val) {
        document.addEventListener("keydown", this.handleKeydown);
      } else {
        document.removeEventListener("keydown", this.handleKeydown);
      }
    },
  },
  methods: {
    getStyle() {
      return {
        width: this.width || "auto",
      }
    },
    handleKeydown(event) {
      if(event.key === "Escape") {
        this.$emit("close");
      }
    },
  },
  mounted() {
    if(this.visible) {
      document.addEventListener("keydown", this.handleKeydown);
    }
  },
  unmounted() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
}
</script>